module.exports = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvD0AAAAfQud60vv+BiOh/AAA="